<template>
	<div class="incenters">
		<div style="">
			<Commonbtn v-if="qx.add" backgroundColor="#FFF" :src="require('@/assets/icon/icon-add.png')" title="新增"
				fontSize="14px" @btnclick="addClick">
			</Commonbtn>
			<Commonbtn v-if="qx.update" backgroundColor="#FFF" :src="require('@/assets/icon/icon-update.png')"
				title="修改" fontSize="14px" @btnclick="editClick">
			</Commonbtn>
			<Commonbtn v-if="qx.del" backgroundColor="#FFF" :src="require('@/assets/icon/icon-del.png')" title="删除"
				fontSize="14px" @btnclick="delClick">
			</Commonbtn>
		</div>
		<div class="TableWidth">
			<Commontable ref="table" :loadingTable="false" @onRowClick="onRowClick" @handleSelectionChange="handleSelectionChange" :hasChecked="false" colnum=522 :tableData="tableData" :headerData="headerData"
				height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total"></Pagination>
			</div>
		</div>

		<!-- 新增/修改弹窗 -->
		<DialogFrom width="600px" :title="dialogTitle" :rigthText="dialogRightText" :dialogVisible="dialogVisible"
			@cancel="cancelDialog" @dialogOK="confirmDialog">
			<div class="CusDialog">
				<FromComm :FromArr="FromArrs" ref="FromArrs"></FromComm>
			</div>
		</DialogFrom>

		<!-- 删除确认弹窗 -->
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleDel" @cancel="cancelDel" @dialogOK="confirmDel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除这条数据吗？</span>
		</Dialog>
	</div>
</template>

<script>
import Commontable from '../../../../components/common-table.vue'
import Commonbtn from '../../../../components/common-btn.vue'
import Pagination from '../../../../components/pagination.vue'
import DialogFrom from '../../../../components/dialog-from.vue'
import Dialog from '../../../../components/dialog.vue'
import FromComm from '../../../views/home/components/fromComponents/Commfrom/from-comm.vue'
import FromArr from '../fromData/FromArr'
import {
	FAQList, FAQAdd, FAQEdit, FAQDelete, FAQInfo
} from '@/api/faq'

export default {
	components: {
		Commontable,
		Commonbtn,
		Pagination,
		DialogFrom,
		Dialog,
		FromComm
	},
	props: {
		tableData: {
			type: Array,
			default: () => []
		},
		total: {
			type: Number,
			default: 0
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			dialogVisible: false,
			dialogVisibleDel: false,
			dialogTitle: '新增常见问题',
			dialogRightText: '确定',
			isEdit: false,
			rowInfo: null,
			multipleSelection: [],
			FromArrs: [],
			qx: {
				add: true, // 默认开启，实际应从权限获取
				update: true,
				del: true
			},
			headerData: [
				{
					prop: 'Title',
					label: '标题',
					columnwidth: 250
				},
				{
					prop: 'InfoContent',
					label: '内容',
				},
				{
					prop: 'CreatorName',
					label: '创建人',
					columnwidth: 150
				},
				{
					prop: 'CreateTime',
					label: '创建时间',
					columnwidth: 200
				}
			]
		}
	},
	mounted() {
		this.FromArrs = JSON.parse(JSON.stringify(FromArr))
		// this.getPermissions() // 如果需要权限控制
	},
	methods: {
		// 列表加载 (由父组件触发)

		onRowClick(val) {
			this.rowInfo = val
		},

		handleSelectionChange(val) {
			this.multipleSelection = val
			if (val.length === 1) {
				this.rowInfo = val[0]
			} else {
				this.rowInfo = null
			}
		},

		// 新增点击
		addClick() {
			this.isEdit = false
			this.dialogTitle = '新增常见问题'
			this.dialogRightText = '确定'
			this.resetForm()
			this.dialogVisible = true
		},

		// 修改点击
		async editClick() {
			if (!this.rowInfo) {
				this.$message.warning('请选择要修改的数据！')
				return
			}

			const loading = this.$loading({
				lock: true,
				text: '正在加载...',
				spinner: 'el-icon-loading',
				background: 'rgba(255,255,255,0.3)'
			});

			try {
				const res = await FAQInfo({ InfoID: this.rowInfo.InfoID })
				if (res.code === 0) {
					this.isEdit = true
					this.dialogTitle = '修改常见问题'
					this.dialogRightText = '修改'
					this.FromArrs[0].modelvalue = res.data.Title
					this.FromArrs[1].modelvalue = res.data.InfoContent
					this.dialogVisible = true
				} else {
					this.$message.warning(res.message)
				}
			} catch (error) {
				console.error(error)
			} finally {
				loading.close()
			}
		},

		// 删除点击
		delClick() {
			if (this.multipleSelection.length > 0) {
				this.dialogVisibleDel = true
				return
			}
			if (this.rowInfo) {
				this.dialogVisibleDel = true
				return
			}
			this.$message.warning('请选择要删除的数据！')
		},

		// 弹窗取消
		cancelDialog() {
			this.dialogVisible = false
		},

		// 弹窗确认
		async confirmDialog() {
			const title = this.FromArrs[0].modelvalue
			const content = this.FromArrs[1].modelvalue

			if (!title) {
				this.$message.warning('请输入标题')
				return
			}

			const params = {
				Title: title,
				InfoContent: content
			}

			let res;
			if (this.isEdit) {
				params.InfoID = this.rowInfo.InfoID
				res = await FAQEdit(params)
			} else {
				res = await FAQAdd(params)
			}

			if (res.code === 0) {
				this.$message.success(this.isEdit ? '修改成功' : '新增成功')
				this.dialogVisible = false
				this.$emit('refresh')
			} else {
				this.$message.error(res.message)
			}
		},

		cancelDel() {
			this.dialogVisibleDel = false
		},

		async confirmDel() {
			if (this.multipleSelection.length > 0) {
				const loading = this.$loading({
					lock: true,
					text: '正在删除...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let successCount = 0;
				let failCount = 0;
				for (const item of this.multipleSelection) {
					try {
						const res = await FAQDelete({
							InfoID: item.InfoID,
							Title: item.Title,
							InfoContent: item.InfoContent
						})
						if (res.code === 0) {
							successCount++;
						} else {
							failCount++;
						}
					} catch (e) {
						failCount++;
					}
				}
				loading.close();
				if (successCount > 0) {
					this.$message.success(`删除成功 ${successCount} 条` + (failCount > 0 ? `，失败 ${failCount} 条` : ''))
					this.dialogVisibleDel = false
					this.$emit('refresh')
					this.multipleSelection = []
					if (this.$refs.table && this.$refs.table.$refs.fileTableSelect) {
						this.$refs.table.$refs.fileTableSelect.clearSelection()
					}
				} else {
					this.$message.error('删除失败')
				}
			} else if (this.rowInfo) {
				const res = await FAQDelete({
					InfoID: this.rowInfo.InfoID,
					Title: this.rowInfo.Title,
					InfoContent: this.rowInfo.InfoContent
				})
				if (res.code === 0) {
					this.$message.success('删除成功')
					this.dialogVisibleDel = false
					this.$emit('refresh')
					this.rowInfo = null
				} else {
					this.$message.error(res.message)
				}
			}
		},

		handleCurrentChange(val) {
			this.$emit('handleCurrentChange', val)
		},

		handleSizeChange(val) {
			this.$emit('handleSizeChange', val)
		},

		resetForm() {
			this.FromArrs.forEach(item => {
				item.modelvalue = ''
			})
		}
	}
}
</script>

<style lang="less" scoped>
.incenters {
	height: 100%;

	.pagination {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		height: 20px;
		padding-top: 20px;
		padding-bottom: 20px;
	}
}

.CusDialog {
	max-height: 500px;
	overflow-y: scroll;
	padding: 20px;
}
</style>
